'use client';

import { useTranslations } from 'next-intl';

import { IconKitMapZoomMinus } from '@/icon/kit/MapZoomMinus';
import { IconKitMapZoomPlus } from '@/icon/kit/MapZoomPlus';

import { styles } from './UiKitMapZoomControls.styles';

export interface UiKitMapZoomControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
}

export function UiKitMapZoomControls({ onZoomIn, onZoomOut }: UiKitMapZoomControlsProps) {
  const slots = styles();
  const t = useTranslations();

  return (
    <div className={slots.base()}>
      <button
        type="button"
        className={slots.button()}
        onClick={onZoomIn}
        aria-label={t('mapZoomIn')}
      >
        <IconKitMapZoomPlus className="size-9" />
      </button>
      <button
        type="button"
        className={slots.button()}
        onClick={onZoomOut}
        aria-label={t('mapZoomOut')}
      >
        <IconKitMapZoomMinus className="size-9" />
      </button>
    </div>
  );
}
